const styles: {[key: string]: React.CSSProperties} = {
  Regular: {
    fontWeight: 400,
  },
  Semibold: {
    fontWeight: 500,
  },
  Bold: {
    fontWeight: 700,
  },
  Italic: {
    fontStyle: 'italic',
  },
  defaultFont: {
    fontFamily: 'RobotoMono',
  },
  resetDefaults: {
    margin: 0,
    padding: 0,
  },
};

export default styles;
